module.exports = __webpack_public_path__ + "img/register-login@2x.17186a48.png";